module.exports = __webpack_public_path__ + "img/invoke.ffbbccda.png";